import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/mfa-verify')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/mfa-verify"!</div>
}
